import { render, staticRenderFns } from "./QueryOverview.vue?vue&type=template&id=838de0c8"
import script from "./QueryOverview.vue?vue&type=script&lang=js"
export * from "./QueryOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports